<div class="w-full h-full overflow-hidden flex flex-col">
  <div class="flex items-center justify-between mb-4 bg-white">
    <div class="flex items-center gap-3">
      <mg-icon iconName="search_activity"
        iconClass="text-xl text-white bg-mg-main-blue-dark rounded-full w-10 h-10 flex items-center justify-center"></mg-icon>
      <span class="text-xl text-mg-main-blue-dark font-bold tracking-tight">Marcaciones</span>
    </div>
    <div class="flex items-center gap-2">
      @if (!showNewRequest) {
        <button mat-button (click)="showHelp = true"
          class="!text-mg-black !text-md !font-medium hover:!text-indigo-600 hover:!bg-indigo-50 !rounded-lg flex items-center gap-1.5 !px-3">
          <mg-icon iconName="info" iconClass="text-lg"></mg-icon>
          Ayuda
        </button>
      }
      
      <button (click)="_dialogRef.close()" mat-icon-button mat-dialog-close class="!text-mg-main-blue">
        <mg-icon iconName="close" iconClass="text-xl leading-none"></mg-icon>
      </button>
    </div>
  </div>
  <div class="flex flex-col md:flex-row flex-1 overflow-hidden min-w-0 gap-4">
    @if (showNewRequest) {
      <mg-new-request-extemp
        [dateSelected]="selectedDate"
        [minDate]="closingDate_request"
        [maxDate]="maxDate"
        [disabledDays]="disabledDays"
        [fechasIncompletas]="fechasIncompletas"
        [fechasSinMarcacion]="fechasSinMarcacion"
        [marksIntervals]="marksIntervals"
        class="w-full h-full flex flex-col overflow-auto md:overflow-hidden min-h-0 pr-2"
        (goBack)="loadCalendar()"
      ></mg-new-request-extemp>
    } @else {
    <div
      class="md:w-96 w-full flex-shrink-0 bg-gray-50/60 md:p-5 p-0 flex flex-col gap-3 md:gap-4 overflow-y-auto min-h-0 max-h-[260px] md:max-h-none md:h-auto self-stretch"
      [ngClass]="(isScreenMD$ | async) ? 'border border-mg-main-blue-light rounded-xl' : ''">
      <div class="w-full flex justify-center items-center flex-shrink-0">
        @if(isScreenMD$ | async){
          <div class="md:w-full w-auto md:scale-100 scale-90 origin-top rounded-xl" [class]="loadingCalendar ? 'bg-white animate-pulse pointer-events-none opacity-60' : ''">
            <mg-calendar-date
              [min]="minDate"
              [max]="maxDate"
              [serie1]="fechasIncompletas"
              titleSerie1="Marcas incompletas" 
              cssSerie1="!bg-mg-gray-light rounded-full w-10 h-10"
              [serie2]="fechasSinMarcacion" 
              titleSerie2="Sin Marcación"
              cssSerie2="!bg-mg-red rounded-full w-10 h-10"
              [serie3]="fechaCierreSerie"
              titleSerie3="Cierres de Planilla"
              cssSerie3="!bg-mg-purple-light rounded-full w-10 h-10"
              (selectDate)="selectDate($event)"
              [selectedDate]="selectDay"
            ></mg-calendar-date>
          </div>
        } @else {
          <div class="w-full" [class]="loadingCalendar ? 'bg-white animate-pulse pointer-events-none opacity-60' : ''">
            <mg-input-date
              [min]="minDate"
              [max]="maxDate"
              label="Fecha de jornada"
              placeholder="DD/MM/AAAA"
              [inputControl]="request.get('dFecha_Inicio') | formTransform:'formControl'"
              class="w-full"
              [serie1]="fechasIncompletas"
              titleserie1="Marcas incompletas" 
              cssserie1="!bg-mg-gray-light rounded-full p-2"
              [serie2]="fechasSinMarcacion"
              titleserie2="Sin Marcación" 
              cssserie2="!bg-mg-red rounded-full p-2"
              [serie3]="fechaCierreSerie"
              titleserie3="Cierres de Planilla"
              cssserie3="!bg-mg-purple-light rounded-full p-2"
              [aDisabledDays]="disabledDays"
              [isDisableErrors]="true"
            ></mg-input-date>
          </div>
        }
      </div>
      <div class="bg-mg-main-blue-light borde border-mg-main-blue rounded-xl p-4 hidden md:block flex-shrink-0">
        <div class="flex items-center gap-1.5 text-md font-semibold text-mg-main-blue-dark mb-2">
          <mg-icon iconName="schedule" iconClass="text-mg-main-blue-dark leading-none text-xl"></mg-icon>
          Horas activas
        </div>
        <div class="text-xl font-bold text-mg-main-blue-dark text-center leading-none">
          {{ horasActivas.split('h')[0] }}<span class="text-xl text-mg-main-blue-dark opacity-70">h</span>
          {{ horasActivas.split('h')[1].replace('m','') }}<span
            class="text-xl text-mg-main-blue-dark opacity-70">m</span>
        </div>
      </div>
      @if (isBeforeClosingDate) {
        <div class="hidden md:flex items-start gap-2 px-3 py-2 rounded-xl bg-mg-purple-relight border border-mg-purple-light text-mg-purple-dark text-xs font-bold w-full"
          [class.shake-badge]="shakeBadge">
          <mg-icon iconName="lock" iconClass="text-xs leading-none flex-shrink-0 mt-0.5"></mg-icon>
          <span class="text-justify leading-snug">No puedes registrar otra solicitud de regularización de marcas, ya que la fecha seleccionada está cerrada.</span>
        </div>
      }
      @if (hasPendingRegularization && !isBeforeClosingDate) {
        <div class="hidden md:flex items-start gap-2 px-3 py-2 rounded-xl bg-mg-sunshine-light border border-mg-sunshine text-mg-sunshine-dark text-xs font-bold w-full"
          [class.shake-badge]="shakeBadge">
          <mg-icon iconName="pending" iconClass="text-xs leading-none flex-shrink-0 mt-0.5"></mg-icon>
          <div class="flex flex-col gap-1">
            <span class="text-justify leading-snug">No puedes registrar otra solicitud de regularización de marcas, ya que cuentas con una pendiente.</span>
            @if (pendingRequestId) {
              <button type="button" class="inline-flex items-center gap-1 w-fit cursor-pointer bg-transparent border-0 p-0 m-0 font-bold text-xs !text-mg-sunshine-dark"
                matTooltip="Ver solicitud pendiente"
                (click)="goToPendingRequest()">
                <mg-icon iconClass="text-sm !text-mg-sunshine-dark" iconName="open_in_new"></mg-icon>
                <span>Ver solicitud pendiente</span>
              </button>
            }
          </div>
        </div>
      }
    </div>
    <div class="flex-1 p-4 md:p-6 flex flex-col overflow-hidden min-w-0 border border-mg-main-blue-light rounded-xl">
      @if (showHelp) {
      <mg-marks-help [selectedDateLabel]="selectedDateLabel" (volver)="showHelp = false"></mg-marks-help>
      } @else {
      <div class="flex items-start justify-between mb-4">
        <div>
          <p class="text-md md:text-xl text-mg-main-blue-dark font-semibold tracking-tight m-0 pb-2">Consulta tus marcaciones</p>
          <p class="text-xs md:text-md text-mg-gray mt-0.5 m-0">{{ selectedDateLabel }}</p>
        </div>
        <span [matTooltip]="newRequestDisabledTooltip"
          [matTooltipDisabled]="!newRequestDisabledTooltip"
          matTooltipPosition="above"
          class="inline-flex">
          <button (click)="showNewRequest = true"
            [disabled]="isNewRequestDisabled"
            class="text-white rounded-full sm:rounded-xl text-sm md:text-md flex items-center justify-center flex-shrink-0 ml-2 bg-mg-green w-10 h-10 sm:w-auto sm:h-auto sm:px-4 sm:py-2 disabled:bg-gray-400 disabled:opacity-60 disabled:cursor-not-allowed transition-all duration-200">
            <mg-icon iconName="add" iconClass="text-xl text-white sm:mr-2"></mg-icon>
            <span class="hidden sm:inline">Nueva Solicitud</span>
          </button>
        </span>
      </div>
      @if (marksHintText && (isScreenMD$ | async)) {
      <div class="bg-mg-main-blue-light border border-mg-main-blue rounded-xl mb-5 overflow-hidden">
        <mat-expansion-panel class="!shadow-none !m-0 !bg-transparent">
          <mat-expansion-panel-header class="!px-4 !py-2.5">
            <mat-panel-title class="flex items-center gap-2">
              <mg-icon iconName="info" iconClass="text-mg-main-blue-dark leading-none text-xl flex-shrink-0"></mg-icon>
              <span class="text-mg-main-blue-dark font-semibold text-xs md:text-md">{{ marksHintText }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="flex flex-col gap-1 px-4 pb-3">
            @for (interval of marksIntervals; track interval.inicio; let i = $index) {
            <span class="text-xs md:text-sm text-mg-main-blue-dark font-semibold">
              • Intervalo {{ i + 1 }}: {{ interval.inicio }} – {{ interval.fin }}
            </span>
            }
          </div>
        </mat-expansion-panel>
      </div>
      }
      <div class="flex flex-col gap-5 flex-1 overflow-y-auto pr-1 pb-2">
        <mg-interval-list 
          [fecha]="selectedDate"
          [nId_Colaborador]="nId_Collaborator"
          [editMode]="false"
          [accionesAgregadas]="[]"
          (intervalsLoaded)="onIntervalsLoaded($event)"
          (loadingChange)="isLoadingIntervals = $event;onIntervalListLoadingChange($event)"
          [ngStyle]="{'display': isLoadingIntervals || hasIntervals ? 'flex' : 'none', 'flex': '1', 'flex-direction': 'column'}"
          (hasPendingRegularization)="onPendingRegularizationChange($event)">
        </mg-interval-list>
        @if (!hasIntervals && !isLoadingIntervals) {
        <div class="flex flex-col items-center justify-center flex-1">
          <img src="../../../../../assets/png/mgalert/no_marks.png" alt="Sin marcaciones"
            class="w-24 h-24 sm:w-40 sm:h-40 md:w-56 md:h-56 xl:h-80 xl:w-80 object-contain opacity-80" />
          <p class="text-xs sm:text-sm font-semibold text-mg-main-blue-dark text-center leading-snug max-w-[160px] sm:max-w-[220px] pt-2">
            No hay registros de asistencia para este día.
          </p>
        </div>
        }
      </div>
      <div class="flex flex-wrap items-center justify-center sm:justify-start gap-2 sm:gap-3 border-t border-mg-gray-light pt-4 mt-5">
        <span
          class="flex items-center gap-1.5 text-xs sm:text-sm font-semibold text-mg-main-blue-dark bg-mg-main-blue-light border border-mg-main-blue px-2.5 sm:px-3 py-1 rounded-xl whitespace-nowrap">
          Total: {{ totalMarcaciones }} <span class="hidden sm:inline">marcaciones</span>
        </span>
        
        @if (totalPendientes > 0) {
        <span
          class="flex items-center gap-1.5 text-xs sm:text-sm font-semibold text-mg-sunshine-dark bg-mg-sunshine-light border border-mg-sunshine px-2.5 sm:px-3 py-1 rounded-xl whitespace-nowrap">
          {{ totalPendientes }} pendiente{{ totalPendientes > 1 ? 's' : '' }}
        </span>
        }
        
        @if (totalAprobadas > 0) {
        <span
          class="flex items-center gap-1.5 text-xs sm:text-sm font-semibold text-mg-green-dark bg-mg-green-light border border-mg-green-dark px-2.5 sm:px-3 py-1 rounded-xl whitespace-nowrap">
          {{ totalAprobadas }} aprobada{{ totalAprobadas > 1 ? 's' : '' }}
        </span>
        }
      </div>
      }
    </div>
    }
  </div>
</div>